import React from 'react';
import last from 'lodash/last';

import { useFormState } from 'react-final-form';

import WpButton from 'Wpds/components/button/WpButton';
import WpButtonGroup from 'Wpds/components/button/WpButtonGroup';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import { SyncMeetingsSteps } from '../../types';

type Props = {
  steps: Array<SyncMeetingsSteps>;
  currentStep: SyncMeetingsSteps;
  onSubmit(): void;
  onNextStep(): void;
  onBackClick(): void;
};

function getPrimaryButtonText({ currentStep, isLastStep, selectedEmail, tr }) {
  switch (currentStep) {
    case SyncMeetingsSteps.inviteTeammates: {
      if (!isLastStep) return tr('perform.sync_meetings.cta.next');
      if (selectedEmail) return tr('perform.common.invite');
      return tr('perform.sync_meetings.cta.finish');
    }
    default:
      return tr('perform.sync_meetings.cta.next');
  }
}

function ButtonsArea({ onSubmit, onBackClick, onNextStep, currentStep, steps }: Props) {
  const {
    submitting,
    errors,
    values: { inviteeEmails },
  } = useFormState();
  const { tr } = useTranslation();

  const selectedEmail = inviteeEmails.some(({ selected }) => selected);
  const isLastStep = currentStep === last(steps);
  const showBackButton = currentStep !== steps[0];
  const primaryButtonText = getPrimaryButtonText({
    currentStep,
    isLastStep,
    selectedEmail,
    tr,
  });

  const errorsExist = !!Object.keys(errors).filter(key => errors[key]).length;

  return (
    <WpButtonGroup>
      {!isLastStep && (
        <WpButton variant="tertiary" qaTest="sync-meetings-skip-button" disabled={submitting} onClick={onNextStep}>
          {tr('perform.sync_meetings.cta.skip')}
        </WpButton>
      )}
      {showBackButton && (
        <WpButton variant="secondary" qaTest="sync-meetings-back-button" disabled={submitting} onClick={onBackClick}>
          {tr('perform.common.back')}
        </WpButton>
      )}
      <WpButton
        btnType="submit"
        qaTest="sync-meetings-submit-button"
        loading={submitting}
        disabled={errorsExist}
        onClick={onSubmit}
      >
        {primaryButtonText}
      </WpButton>
    </WpButtonGroup>
  );
}

export default ButtonsArea;
